var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecurityTabsLines = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 99,
  height: 285,
  fill: "none",
  viewBox: "0 0 99 285"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1E7",
  strokeDasharray: "4 4",
  strokeLinecap: "round",
  d: "M26 143h72",
  className: "line",
  vectorEffect: "non-scaling-stroke"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1E7",
  strokeDasharray: "4 4",
  strokeLinecap: "round",
  d: "M2 1h14c5.523 0 10 4.477 10 10v132",
  className: "line-0",
  vectorEffect: "non-scaling-stroke"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1E7",
  strokeDasharray: "4 4",
  strokeLinecap: "round",
  d: "M1 143h24",
  className: "line-1",
  vectorEffect: "non-scaling-stroke"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1E7",
  strokeDasharray: "4 4",
  strokeLinecap: "round",
  d: "M2 283.5h14c5.523 0 10-4.477 10-10V143",
  className: "line-2",
  vectorEffect: "non-scaling-stroke"
})));
export { SvgSecurityTabsLines as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTkiIGhlaWdodD0iMjg1IiB2aWV3Qm94PSIwIDAgOTkgMjg1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgoJPHBhdGggY2xhc3M9ImxpbmUiIGQ9Ik0yNiAxNDNIOTgiIHN0cm9rZT0iI0RBRTFFNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDQiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgLz4KCTxwYXRoIGNsYXNzPSJsaW5lLTAiIGQ9Ik0yIDFDNy41Mzc5MiAxIDExLjYzODMgMSAxNS45OTk4IDFDMjEuNTIyNyAxIDI2IDUuNDc3MTUgMjYgMTFWMTQzIiBzdHJva2U9IiNEQUUxRTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iNCA0IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIC8+Cgk8cGF0aCBjbGFzcz0ibGluZS0xIiBkPSJNMS4wMDAwMiAxNDNIMjUiIHN0cm9rZT0iI0RBRTFFNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDQiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgLz4KCTxwYXRoIGNsYXNzPSJsaW5lLTIiIGQ9Ik0yIDI4My41QzcuNTM3OTIgMjgzLjUgMTEuNjM4MyAyODMuNSAxNS45OTk4IDI4My41QzIxLjUyMjcgMjgzLjUgMjYgMjc5LjAyMyAyNiAyNzMuNVYxNDMiIHN0cm9rZT0iI0RBRTFFNyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDQiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgLz4KPC9zdmc+Cg==";